export const GET_SIMULATION_DATA = 'GET_SIMULATION_DATA';
export const SAVE_SIMULATION = 'SAVE_SIMULATION';